export default __webpack_public_path__ + "static/MiroIcon-d272fea510dc73dec9ef8f50b79da5af.svg";